import InnerComponent from '@Components/Purchase/PurchaseOrders/PurchaseOrdersHome';
import orgContainer from '@Components/AppContainer';

const OrgPurchaseOrders = () => ((orgContainer(InnerComponent)));
export default OrgPurchaseOrders;
